export const initVideoBanner = () => {
    const banner = document.querySelector(".job-details-cta-video-bottom");
    if (!banner) return;

    const link = document.querySelector<HTMLElement>(
        '.page-job-details .job-information-url .attrax-job-information-widget__dynamic-field-value'
    );
    const url = link?.textContent?.trim();

    const playButton = banner.querySelector<HTMLElement>(".job-details-video-banner__play-button");

    if (!url) {
        if (playButton) playButton.style.display = "none";
        return;
    }

    const iframe = banner.querySelector<HTMLIFrameElement>("iframe");

    if (!iframe) return;

    iframe.setAttribute("src", toEmbedUrl(url));
};

const toEmbedUrl = (url: string): string => {
    if ((url.includes("youtube") || url.includes("youtu.be")) && !url.includes("embed")) {
        const videoIdMatch = url.match(/(?:v=|youtu\.be\/|\/)([0-9A-Za-z_-]{11})(?:[&?#]|$)/);
        if (videoIdMatch) {
            return `https://www.youtube.com/embed/${videoIdMatch[1]}`;
        }
    }

    if (url.includes("vimeo") && !url.includes("player.vimeo.com")) {
        const videoIdMatch = url.match(/vimeo\.com\/(?:.*\/)?(\d+)(?:[?#].*)?$/);
        if (videoIdMatch) {
            return `https://player.vimeo.com/video/${videoIdMatch[1]}`;
        }
    }

    return url;
};
